<template lang='pug'>
	.privacy-policy
		v-e24-nav-bar
		headerResources(:srcImage='img', isAccordions='true', :tall="tall", h1="Cost Estimator for Residential & Commercial Title24 Report")
		contentPrivacy
		v-e24-footer(:build="build")
</template>
<script>
import headerResources from '@/commonSite/header.vue'
import contentPrivacy from '@/components/resources/content-cost-estimator.vue'
import imageHeader from '@/img/prices-header.jpg'
import readBuild from '../util/readBuild'

export default {
	name: 'cost-estimator',
	components: {
		headerResources,
		contentPrivacy
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Cost-estimator.vue